var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_665)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.0001,
    cy: 9.99743,
    rx: 10.0001,
    ry: 9.99743,
    fill: "#1977F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8968 12.8905L14.3403 9.99886H11.5661V8.1231C11.5661 7.33281 11.9529 6.56058 13.1969 6.56058H14.4585V4.09961C14.4585 4.09961 13.3131 3.9043 12.2191 3.9043C9.93473 3.9043 8.44066 5.28834 8.44066 7.79571V9.99887H5.90039V12.8905H8.44066V19.8786C8.94959 19.9585 9.47122 19.9992 10.0036 19.9992C10.5345 19.9992 11.0571 19.9573 11.5661 19.8786V12.8905L13.8968 12.8905Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.0003,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/FacebookLogo.3d817ea1761ff9ce8484383e9d25f49d.svg";
export { ForwardRef as ReactComponent };